'use client';

import { usePermission, useUserSubscriptions } from '@benzinga/user-context';

import type { PremiumServiceAccess } from '../premiumServiceLinks';

export const usePremiumServiceAccess = (isLoggedIn: boolean): PremiumServiceAccess => {
  const subscriptions = useUserSubscriptions();
  const hasProDashboard = usePermission('bzpro/dashboard/open', '#');
  const hasResearchAccess = usePermission('trade-alerts/access', 'true');
  const hasEdgeSubscription = usePermission('com/read', 'unlimited-calendars');

  const hasAccessibleSub = (check: (product: string, basePlan: string) => boolean) =>
    subscriptions?.some(
      sub => (sub.status === 'active' || sub.status === 'trialing') && check(sub.product, sub.basePlan ?? ''),
    ) ?? false;

  return {
    hasEdge:
      isLoggedIn &&
      (hasEdgeSubscription ||
        hasAccessibleSub((_product, basePlan) => basePlan.toLowerCase().includes('benzinga-edge'))),
    hasPro: isLoggedIn && (hasProDashboard || hasAccessibleSub(product => product === 'benzinga-pro')),
    hasResearch:
      isLoggedIn &&
      (hasResearchAccess ||
        hasAccessibleSub(product => ['benzinga-newsletter', 'benzinga-plus', 'benzinga-premium'].includes(product))),
  };
};
